<template>
  <div class="certificate">
    <div class="grid-container">
      <div v-for="item in certificateListing" :key="item.id" class="grid-item certificate-logo">
        <img :src="require('@/'+item.imagePath)" :alt="item.alt">
      </div>

      <!-- <div class="grid-item certificate-logo">
        <img src="../assets/images/home/MIA_w_trans.png" alt="">
      </div>
      <div class="grid-item certificate-logo">
        <img src="../assets/images/home/LHDN.png" alt="">
      </div>
      <div class="grid-item certificate-logo">
        <img src="../assets/images/home/CTIM_w_trans.png" alt="">
      </div>
      <div class="grid-item certificate-logo">
        <img src="../assets/images/home/SSM_w_trans.png" alt="">
      </div>
      <div class="grid-item certificate-logo">
        <img src="../assets/images/home/HRDC.png" alt="">
      </div> -->
    </div>
  </div>
</template>

<script>

export default {
  name: 'certificate',
  data: function () {
    return {
      certificateListing: []
    }
  },
  props: {
    // content: {
    //   type: String,
    //   required: true,
    //   default: ''
    // }
  },
  computed: {
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      const res = await fetch('../data-lists/certificate.json')
      const val = await res.json()
      this.certificateListing = val
    }
  }
}
</script>
